import { Card, CardContent } from '@/components/ui/card';

export default function FAQ() {
  const faqs = [
    {
      question: "What is FixMyHood?",
      answer:
        "FixMyHood is a platform designed for residential estates to manage issues and tasks, streamline communication, and generate monthly reports in one place.",
    },
    {
      question: "Who is this for?",
      answer:
        "It’s built for estate managers, trustees, and HOAs looking for a simpler and more organized way to manage estate operations.",
    },
    {
      question: "What problems does it solve?",
      answer:
        "FixMyHood helps eliminate lost or untracked issues, reduces scattered communication (like WhatsApp), and simplifies monthly reporting.",
    },
    {
      question: "How does onboarding work?",
      answer:
        "You’ll be guided through setup step-by-step. Most estates can be up and running quickly, with support available if needed.",
    },
    
    {
      question: "How much does it cost?",
      answer:
        "Pricing depends on estate size. You can view pricing on the website or get in touch to discuss what works best for your estate.",
    },
    {
      question: "Is my data secure?",
      answer:
        "Yes. Data is securely stored and access is restricted per estate. Security and privacy are a top priority.",
    },
    
    {
      question: "Can we try it before committing?",
      answer:
        "Yes. Early access is available so estates can try the platform and provide feedback before fully committing.",
    },
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-center">
          General FAQ's 
        </h1>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <Card key={index} className="border-2">
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold mb-2">
                  {faq.question}
                </h3>
                <p className="text-muted-foreground">
                  {faq.answer}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground">
            Still have questions?
          </p>
          <a
            href="mailto:support@fixmyhood.app"
            className="text-[#1883FF] font-medium hover:underline"
          >
            support@fixmyhood.app
          </a>
        </div>
      </div>
    </div>
  );
}